import {asset} from 'imba';
import url from './health_alt.svg';

export default /* @__PURE__ */ asset({
	url: url,
	type: 'svg',
	meta: {"attributes":{"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"},"flags":[],"content":"\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M48 0H0V48H48V0ZM8.99993 5.99996C7.34307 5.99996 5.99993 7.34311 5.99993 8.99996L5.99993 39C5.99993 40.6568 7.34307 42 8.99993 42H38.9999C40.6568 42 41.9999 40.6568 41.9999 39V8.99996C41.9999 7.34311 40.6568 5.99996 38.9999 5.99996L8.99993 5.99996ZM22.0002 14V22H14.0002L14.0002 26L22.0002 26V34L26.0002 34V26H34.0002V22H26.0002V14L22.0002 14Z\" fill=\"#333333\"/>\n\n"},
	toString: function(){ return this.url;}
})